const androidCheck = () => {
  if (navigator) {
    return /android/i.test(navigator.userAgent);
  }
  return false;
};

export default androidCheck;
